export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./testPaper.vue?vue&type=template&id=4369d98c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/testPaper.vue?vue&type=template&id=4369d98c&scoped=true&
// module id = null
// module chunks = 